import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { useSession } from "@/lib/auth/client";
import { AppSidebar } from "./IconSidebar";
import { ThemeToggle } from "./ThemeToggle";

export function DashboardLayout({
  children,
  fullBleed,
}: {
  children: React.ReactNode;
  fullBleed?: boolean;
}) {
  const { data: session } = useSession();

  return (
    <SidebarProvider defaultOpen={false}>
      <AppSidebar />
      <SidebarInset>
        {/* Header */}
        <header className="flex h-16 items-center justify-between border-b border-border/50 bg-background px-4 md:px-6">
          <SidebarTrigger className="md:hidden -ml-1" />
          <div className="text-sm text-muted-foreground hidden md:block">Dashboard</div>
          <div className="flex items-center gap-3">
            <ThemeToggle />
            {session?.user && (
              <Avatar className="size-8">
                <AvatarFallback className="bg-primary text-primary-foreground text-sm font-medium">
                  {session.user.name?.charAt(0).toUpperCase() ?? "U"}
                </AvatarFallback>
              </Avatar>
            )}
          </div>
        </header>

        {/* Scrollable content */}
        <main
          className={fullBleed ? "flex-1 overflow-hidden" : "flex-1 overflow-y-auto p-4 md:p-8"}
        >
          {fullBleed ? children : <div className="mx-auto max-w-5xl">{children}</div>}
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
